module.exports = __webpack_public_path__ + "media/images/footer/pl_efs-9f11fdb2ed0cbea5a2dccac9b3a776f5.svg";